import { Card as CardId, Seat } from "@ravalmatic/bridge-engine/core";
import { HandMode } from "../../../Types";
import { BasePlayerContainer } from "./BasePlayerContainer";
import { GameVars } from "../../../GameVars";
import { PlayerLayout } from "../BoardLayoutManager";

export class AdversaryContainer extends BasePlayerContainer {

    private avatarDefaultX = 0;

    constructor(scene: Phaser.Scene, seat: Seat, cards: readonly CardId[]) {

        super(scene, seat, cards, HandMode.HIDDEN);
        this.hand.setVisible(false);
    }

    public applyLayout(layout: PlayerLayout): void {

        super.applyLayout(layout);
        this.avatarDefaultX = layout.avatar.x;
    }

    public setBiddingPhase(active: boolean, onComplete?: () => void): void {

        const offset = this.seat === 1 ? 75 : this.seat === 3 ? -75 : 0;
        if (active) {
            this.positionAvatar(this.avatarDefaultX + offset, this.avatar.y);
            onComplete?.();
        } else if (this.seat === 1 || this.seat === 3) {
            this.positionAvatar(this.avatarDefaultX, this.avatar.y, 500, onComplete);
        } else {
            onComplete?.();
        }
    }

    public finishBiddingPhase(onComplete: () => void): void {

        let pending = 2;
        const animationFinished = () => {
            pending--;
            if (pending === 0) {
                onComplete();
            }
        };
        this.setBiddingPhase(false, animationFinished);

        const x = this.hand.x;
        const y = this.hand.y;
        const bounds = this.hand.getBounds();
        const margin = 32;

        switch (this.seat) {
            case 0:
                this.hand.y -= (bounds.bottom + margin) / this.scaleY;
                break;
            case 1:
                this.hand.x += GameVars.gameWidth - bounds.left + margin;
                break;
            case 3:
                this.hand.x -= bounds.right + margin;
                break;
        }

        this.hand.setVisible(true);
        this.scene.tweens.add({
            targets: this.hand,
            x,
            y,
            delay: 1000,
            duration: 500,
            ease: "Cubic.Out",
            onComplete: animationFinished
        });
    }
}
